var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.component,{tag:"component",attrs:{"section":_vm.section}},[_c('div',{staticClass:"alert"},[_vm._v("Es ist ein Fehler aufgetreten")])])}
var staticRenderFns = []

export { render, staticRenderFns }